import React, { useEffect, useState } from 'react';
import { ArrowLeftRight, Eye } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const left = (iso) => Math.max(0, new Date(iso).getTime() - Date.now());

export default function ImpersonationBar() {
  const { impersonation, stopImpersonation } = useAuth();
  const [ms, setMs] = useState(() => (impersonation ? left(impersonation.expiresAt) : 0));
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!impersonation) return undefined;
    const t = setInterval(() => setMs(left(impersonation.expiresAt)), 1000);
    return () => clearInterval(t);
  }, [impersonation]);

  useEffect(() => {
    if (impersonation && ms === 0 && !busy) { setBusy(true); stopImpersonation(); }
  }, [ms, impersonation, busy, stopImpersonation]);

  if (!impersonation) return null;
  const mm = Math.floor(ms / 60000);
  const ss = String(Math.floor((ms % 60000) / 1000)).padStart(2, '0');
  const back = () => { setBusy(true); stopImpersonation(); };
  return (
    <div className="fixed top-[76px] right-3 z-[100] flex items-center gap-3 rounded-full bg-amber-500 text-black pl-4 pr-1.5 py-1.5 shadow-2xl shadow-amber-500/30" data-testid="impersonation-bar">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="text-sm font-medium max-w-[46vw] truncate" data-testid="impersonation-user">
        Logged in as {impersonation.userName || impersonation.userEmail}
      </span>
      <span className="text-xs font-mono opacity-80 hidden sm:inline" data-testid="impersonation-timer">{mm}:{ss}</span>
      <button type="button" onClick={back} disabled={busy}
        className="flex items-center gap-1.5 rounded-full bg-black text-amber-300 px-3 py-1.5 text-xs font-semibold hover:bg-zinc-800 transition-colors disabled:opacity-60"
        data-testid="switch-back-btn">
        <ArrowLeftRight className="h-3.5 w-3.5" />{busy ? 'Switching...' : 'Switch back'}
      </button>
    </div>
  );
}
